import { useTranslation } from 'react-i18next';
import Navbar from 'src/components/NavBar';
import useWindowSize from 'src/hooks/useWindowSize';
import ShoppingListProductsFilters from './ShoppingListProductsFilters';
import ShoppingListProductsHeader from './ShoppingListProductsHeader';
import ToggleShoppingListProductView from './ToggleShoppingListProductView';
import 'src/style/select-company/SelectCompany.scss';
import 'src/style/shopping-lists/ShoppingListLayout.scss';

const ShoppingListLayout = () => {
  const { height } = useWindowSize();
  const { t } = useTranslation();

  return (
    <div className="shopping-list-layout min-w-0 overflow-x-hidden" style={{ height: `${height}px` }}>
      <div
        className="mb-2 min-h-0 min-w-0 bg-white"
        style={{ gridArea: 'navbar' }}
      >
      <Navbar title={t('Shopping List Details')} />
        <ShoppingListProductsHeader />
        <ShoppingListProductsFilters />
      </div>
      <ToggleShoppingListProductView />
    </div>
  );
};

export default ShoppingListLayout;
